import { render, staticRenderFns } from "./RootLoadingSpinner_35.vue?vue&type=template&id=21fc52ac&"
import script from "./RootLoadingSpinner_35.vue?vue&type=script&lang=js&"
export * from "./RootLoadingSpinner_35.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports